export default __webpack_public_path__ + "static/KeywordResearch_01_02-8f4fc92e2ef924acfa3adc1751e95b21.webp";